export const StatusDefinitions = {
  maintenance: {
    PENDING: {
      value: "Pending",
      color: "ct_pending_badge",
      dot: "pending-dot",
    },
    APPROVED: {
      value: "Approved",
      color: "ct_active_badge",
      dot: "active-dot",
    },
    REJECTED: {
      value: "Rejected",
      color: "ct_inactive_badge",
      dot: "inactive-dot",
    },
  },
  invoice: {
    0: {
      value: "Pending",
      color: "ct_pending_badge",
      dot: "pending-dot",
    },
    1: {
      value: "Paid",
      color: "ct_active_badge",
      dot: "active-dot",
    },
  },
  jobHis: {
    ASSIGNED: {
      value: "Assigned",
      color: "ct_active_badge",
      dot: "active-dot",
    },
    UNASSIGNED: {
      value: "Unassigned",
      color: "ct_inactive_badge",
      dot: "inactive-dot",
    },
    COMPLETE: {
      value: "Complete",
      color: "ct_active_badge",
      dot: "active-dot",
    },
    INCOMPLETE: {
      value: "Incomplete",
      color: "ct_inactive_badge",
      dot: "inactive-dot",
    },
    Pending: {
      value: "Pending",
      color: "ct_pending_badge",
      dot: "pending-dot",
    },
    PENDING: {
      value: "Pending",
      color: "ct_pending_badge",
      dot: "pending-dot",
    },
    Completed: {
      value: "Completed",
      color: "ct_active_badge",
      dot: "active-dot",
    },
    COMPLETED: {
      value: "Completed",
      color: "ct_active_badge",
      dot: "active-dot",
    },
    OVERDUE: {
      value: "Overdue",
      color: "ct_inactive_badge",
      dot: "inactive-dot",
    },
    IN_PROGRESS: {
      value: "In Progress",
      color: "ct_pending_badge",
      dot: "pending-dot",
    },
    STARTED: {
      value: "Commenced",
      color: "ct_pending_badge",
      dot: "pending-dot",
    },
    PAUSED: {
      value: "Paused",
      color: "ct_pending_badge",
      dot: "pending-dot",
    },
    INVOICED: {
      value: "Invoiced",
      color: "ct_active_badge",
      dot: "active-dot",
    },
  },
  activebooking: {
    active: {
      value: "Active",
      color: "ct_active_badge",
      dot: "active-dot",
    },
    completed: {
      value: "Completed",
      color: "ct_inactive_badge",
      dot: "inactive-dot",
    },
    upcoming: {
      value: "Upcoming",
      color: "ct_pending_badge",
      dot: "pending-dot",
    },
  }
};


export const weightOptions = [
  {
    label: "Up to 500 KG",
    value: "UP_TO_500_KG",
  },
  {
    label: "Up to 1 Ton",
    value: "UP_TO_1_TON",
  },
  {
    label: "Up to 2 Tons",
    value: "UP_TO_2_TONS",
  },
  {
    label: "Up to 5 Tons",
    value: "UP_TO_5_TONS",
  },
  {
    label: "Up to 10 Tons",
    value: "UP_TO_10_TONS",
  },
  {
    label: "Over 10 Tons",
    value: "OVER_10_TONS",
  },
];

export const lengthOptions = [
  {
    label: "Up to 5 FT",
    value: "UP_TO_5_FT",
  },
  {
    label: "5 to 10 FT",
    value: "5_TO_10_FT",
  },
  {
    label: "10 to 20 FT",
    value: "10_TO_20_FT",
  },
  {
    label: "20 to 30 FT",
    value: "20_TO_30_FT",
  },
  {
    label: "30 to 40 FT",
    value: "30_TO_40_FT",
  },
  {
    label: "40+ FT",
    value: "40_PLUS_FT",
  },
];
